/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

import moment from "moment";

// @mui material components
import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";

// Soft UI Dashboard PRO React example components
import DashboardLayout from "template/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "template/examples/Navbars/DashboardNavbar";
import Footer from "template/examples/Footer";
import TimelineList from "components/Timelines/TimelineList";
import SoftTypography from "components/SoftComponents/SoftTypography";

const humanizeDuration = require("humanize-duration");
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import { useEffect } from "react";

function getSecondsBetweenDates(start_time, end_time) {
    const start_time_moment = moment(start_time);
    const end_time_moment = moment(end_time);
    if (start_time_moment.isValid() && end_time_moment.isValid()) {
        return end_time_moment.diff(start_time_moment, 'seconds');
    }
}

function generateMomentString(input) {
    // console.log(input)
    let format = "h:mm A - ddd Do MMM";
    if (!input.isSame(new Date(), 'year')) {
        format += " YYYY"
    }

    return input.format(format);
}

function NextEvent({ data, group_name, groupID }) {
    var now = moment().unix();

    var upcoming_events = data.filter((event) => {
        var ret = {};

        for (var group of event.groups) {
            if (Number(group.group_id) == groupID) {
                ret.event = event;
                ret.event.exception = group.exception;
                return ret;
            }
        }
    }).filter(event => moment(event.end_time).unix() > now);

    var seconds_in_advance = 0;
    var seconds_on_display = 0;

    var display_time = 0;
    var start_time = 0;
    var end_time = 0;

    if (upcoming_events.length > 0) {
        seconds_in_advance = getSecondsBetweenDates(upcoming_events[0].display_time, upcoming_events[0].start_time);
        seconds_on_display = getSecondsBetweenDates(upcoming_events[0].start_time, upcoming_events[0].end_time);

        display_time = moment(upcoming_events[0].display_time);
        start_time = moment(upcoming_events[0].start_time);
        end_time = moment(upcoming_events[0].end_time);
    }

    // console.log(upcoming_events)

    return (
        <SoftBox height={'100%'}>
            <TimelineList title="Clearway Timeline" subtitle={moment().format("DD/MM/YYYY")} sx={{ height: '100%' }}>
                {upcoming_events.length == 0 && (
                    <SoftBox p={2} pl={3}>
                        <SoftTypography variant="h5">
                            Not In Use!
                        </SoftTypography>
                    </SoftBox>
                )}
                {upcoming_events.length > 0 && (<>
                    <Timeline sx={{ paddingLeft: '16px', paddingY: '0px' }}>
                        <TimelineItem>
                            <TimelineOppositeContent color="text.secondary">
                                {generateMomentString(display_time)}
                            </TimelineOppositeContent>
                            <TimelineSeparator>
                                <TimelineDot />
                                <TimelineConnector />
                            </TimelineSeparator>
                            <TimelineContent>Event Warning Starts</TimelineContent>
                        </TimelineItem>
                        <TimelineItem>
                            <TimelineOppositeContent color="text.secondary">
                                {humanizeDuration(seconds_in_advance * 1000)}
                            </TimelineOppositeContent>
                            <TimelineSeparator>
                                <TimelineConnector />
                            </TimelineSeparator>
                            <TimelineContent>Warning Period</TimelineContent>
                        </TimelineItem>
                        <TimelineItem>
                            <TimelineOppositeContent color="text.secondary">
                                {generateMomentString(start_time)}
                            </TimelineOppositeContent>
                            <TimelineSeparator>
                                <TimelineDot />
                                <TimelineConnector />
                            </TimelineSeparator>
                            <TimelineContent>Special Event Starts</TimelineContent>
                        </TimelineItem>
                        <TimelineItem>
                            <TimelineOppositeContent color="text.secondary">
                                {humanizeDuration(seconds_on_display * 1000)}
                            </TimelineOppositeContent>
                            <TimelineSeparator>
                                <TimelineConnector />
                            </TimelineSeparator>
                            <TimelineContent>Display Period</TimelineContent>
                        </TimelineItem>
                        <TimelineItem>
                            <TimelineOppositeContent color="text.secondary">
                                {generateMomentString(end_time)}
                            </TimelineOppositeContent>
                            <TimelineSeparator>
                                <TimelineDot />
                            </TimelineSeparator>
                            <TimelineContent>Special Event Ends</TimelineContent>
                        </TimelineItem>
                    </Timeline>
                </>)}
            </TimelineList>
        </SoftBox>
    );
}


// Typechecking props for the Calendar
NextEvent.propTypes = {
    data: PropTypes.array,
    group_name: PropTypes.string,
    groupID: PropTypes.number
};

export default NextEvent;